

module.exports = function (settingsService, $document, $timeout, $compile) {
    return {
        restrict: 'EA',
        compile: (tElement, tAttr) => {
            if (tElement.prop('tagName') === 'IMG') {
                return {
                    post: function postLink(scope, element) {

                        function checkInView() {
                            const pageTop = $(window).scrollTop();
                            const pageBottom = pageTop + ($(window).height() * 2);
                            const elementTop = element.offset().top;
                            const elementBottom = elementTop + element.height();
                            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
                        }

                        settingsService.getSettingValue('Content', 'EnableLazilyLoadedImages').then((enabled) => {
                            if (enabled) {
                                if (!checkInView()) {
                                    $timeout(() => {
                                        tElement.attr('src', tAttr.lazySrc);
                                    }, 2000);
                                } else {
                                    tElement.attr('src', tAttr.lazySrc);
                                }
                            } else {
                                tElement.attr('src', tAttr.lazySrc);
                            }
                        });


                    },
                };
            }
            const content = tElement.html();
            tElement.html('');
            return {
                post: function postLink(scope, element) {

                    settingsService.getSettingValue('Content', 'EnableLazilyLoadedImages').then((enabled) => {
                        if (enabled) {
                            let timeoutFree;
                            let isContentSet = false;
                            scope.$on('http:request', () => {
                                if (!isContentSet) {
                                    if (timeoutFree) {
                                        $timeout.cancel(timeoutFree);
                                    }
                                    timeoutFree = $timeout(() => {
                                        element.html(content);
                                        $compile(element.contents())(scope);
                                        isContentSet = true;
                                    }, 1000);
                                }
                            });
                        } else {
                            element.html(content);
                            $compile(element.contents())(scope);
                        }
                    });


                },
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/lazy-load-component/lazyloadcomponent.directive.js